import { cloneDeep } from "lodash"

import {
  GetOrderDetailsResponseType,
  OrderItemType,
  ProductCategoryTypes,
} from "@mono/essentials/types/OrderTypes"

export const getGroupedAddonsOfAOrderItem = ({
  orderItem,
  orderData,
}: {
  orderItem: OrderItemType
  orderData?: GetOrderDetailsResponseType
}) => {
  const groupedAddons: OrderItemType[] = []
  cloneDeep(orderData)
    ?.items.filter(
      (oi) =>
        oi.product.type.internal_type === ProductCategoryTypes.ADD_ONS &&
        oi.parent_id === orderItem.id
    )
    .forEach((addon) => {
      const addonProductIndex = groupedAddons.findIndex(
        (ga) => ga?.product?.id && addon?.product?.id && ga?.product?.id === addon?.product?.id
      )
      if (addonProductIndex >= 0) {
        // We need orderItemId of the each add-on to update it's price.So order-item-id is passed to every quantity.
        groupedAddons[addonProductIndex]?.quantities?.push(
          ...(addon?.quantities?.map((quantityInfo) => ({
            ...quantityInfo,
            orderItemId: addon.id,
          })) ?? [])
        )
      } else {
        groupedAddons.push(addon)
      }
    })
  return groupedAddons
}
